export const NEWS = 'news';
export const NEW_BUIDINGS = 'new_buildings';
export const ALL_COMPLEXES = 'Все комплексы';
